import { useTableColumns } from "./columns";

import type { IDoctorInformationProps } from ".";

import { ListBox } from "@/components/molecules/listBox";

export function DoctorInformation(props: IDoctorInformationProps) {
  const { data, isLoading, isError } = props;
  const columnDef = useTableColumns();

  return (
    <ListBox
      title={"infoSubtitle.doctor"}
      iconName={"UserRounded"}
      showRow={false}
      columnDef={columnDef}
      dataJSON={Array(data!)}
      isLoading={isLoading}
      isError={isError}
    />
  );
}
